import type { Components, Theme } from '@mui/material/styles';

export const MuiSkeleton: Components<Theme>['MuiSkeleton'] = {
  defaultProps: { variant: 'rounded' },
};
